export const DEFAULT_PAGE_URI = '/data-security/';

/**
 * Enum for the pages in the app available in the app.
 * @enum PAGES
 */
export enum PAGES {
  /**
   * Root app service in cloud console.
   */
  ROOT_APP_SERVICE = 'AX_DATA_SECURITY_APP_SERVICE',
  /**
   * Layout for the app.
   */
  APP = 'AX_DATA_SECURITY_APP',
  /**
   * Home page.
   */
  HOME = 'AX_DATA_SECURITY_HOME',
  /**
   * Manage Federations page.
   */
  MANAGE_FEDERATIONS = 'AX_DATA_SECURITY_MANAGE_FEDERATIONS',
  /**
   * Federations page.
   */
  FEDERATIONS = 'AX_DATA_SECURITY_FEDERATIONS',
  /**
   * Create Federations page.
   */
  CREATE_FEDERATION = 'AX_DATA_SECURITY_CREATE_FEDERATIONS',
  /**
   * Update Federations page.
   */
  UPDATE_FEDERATION = 'AX_DATA_SECURITY_UPDATE_FEDERATION',
  /**
   * Testing page.
   */
  TESTING = 'TESTING',
  /**
   * Landing page.
   */
  LANDING_PAGE = 'LANDING_PAGE',
}

const PAGE_CONSTANTS = {
  /**
   * Root app service in cloud console.
   */
  ROOT_APP_SERVICE: 'AX_DATA_SECURITY_APP_SERVICE',
  /**
   * Layout for the app.
   */
  APP: 'AX_DATA_SECURITY_APP',
  /**
   * Home page.
   */
  HOME: 'AX_DATA_SECURITY_HOME',
  /**
   * Not found page.
   */
  NOT_FOUND: 'AX_DATA_SECURITY_NOT_FOUND',
  /**
   * Federations page.
   */
  FEDERATIONS: 'AX_DATA_SECURITY_FEDERATIONS',
  /**
   * Manage Federations page.
   */
  MANAGE_FEDERATIONS: 'AX_DATA_SECURITY_MANAGE_FEDERATIONS',
  /**
   * Create Federations page.
   */
  CREATE_FEDERATION: 'AX_DATA_SECURITY_CREATE_FEDERATIONS',
  /**
   * Update Federations page.
   */
  UPDATE_FEDERATION: 'AX_DATA_SECURITY_UPDATE_FEDERATION',
  /**
   * Home page.
   */
  DATA_SECURITY: 'AX_DATA_SECURITY_HOME',
  /**
   * Testing page.
   */
  TESTING: 'TESTING',
  /**
   * Landing page.
   */
  LANDING_PAGE: 'LANDING_PAGE',
  /**
   * Authentication Policy Settings Page.
   */
  AUTHENTICATION_POLICY_SETTINGS_PAGE: 'AUTHENTICATION_POLICY_SETTINGS_PAGE',
};

export default PAGE_CONSTANTS;
